// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6b2a10ea","453":"e2c48391"}[chunkId] + ".chunk.js";
};